import React from 'react'
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { mobile } from '../responsive';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

const Container = styled.div`
    background: rgb(238,174,202);
    background: radial-gradient(circle, 
                                rgba(238,174,202,1) 0%, 
                                rgba(148,187,233,1) 100%);
    width: 100%;
    height: 7vh;
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    top: 11vh;
    z-index: 1;
    

    ${mobile({
        position: 'fixed',
        top: '11vh',
        right: 0,
        marginRight: '8px',
        width: '30vw',
        height: '80vh',
        flexDirection: 'column',
        justifyContent: 'space-around',
        display: props => props.show ? '' : 'none'

    })};

`

const LabelCard = styled.div`
    border-radius: 10px;
    background-color: ${props => props.active ? 'white' : 'teal'};
    color: ${props => props.active ? 'teal' : 'white'};;
    margin: 10px;
    padding: 5px 15px;
    align-items: center;
    justify-content: center;
    text-align: center;
    
    cursor: pointer;

    &:hover{
        background-color: white;
        color: teal;
    }

    ${mobile({
        margin: '10px',
        padding: '10px',
    })};
`

const NavLink = styled(Link)`
    text-decoration: none;
    color: inherit;
    
`

const NavBar = () => {
    
    const sideNav = useSelector(state => state.sideNav);
    const showNav = sideNav?.showNav;
    const location = useLocation();
    const path = location.pathname.split("/")[1];
    
    return (
        <Container show={showNav}>
            <LabelCard active={path === ''}>
                <NavLink to='/'>Home</NavLink>
            </LabelCard>
            <LabelCard active={path === 'vouchers'}>
                <NavLink to='/vouchers'>Vouchers</NavLink>
            </LabelCard>
            <LabelCard active={path === 'departments'}>
                <NavLink to='/departments'>Departments</NavLink>
            </LabelCard>
            <LabelCard active={path === 'locations'}>
                <NavLink to='/locations'>Locations</NavLink>
            </LabelCard>
            <LabelCard active={path === 'sections'}>
                <NavLink to='/sections'>Sections</NavLink>
            </LabelCard>
            <LabelCard active={path === 'payees'}>
                <NavLink to='/payees'>Payees</NavLink>
            </LabelCard>
            <LabelCard active={path === 'banks'}>
                <NavLink to='/banks'>Banks</NavLink>
            </LabelCard>
            <LabelCard active={path === 'projects'}>
                <NavLink to='/projects'>Projects</NavLink>
            </LabelCard>
        </Container>
    )
}

export default NavBar
